<template>
  <v-card class="layers-menu rounded-lg">
    <v-row no-gutters>
      <v-col>
        <v-btn
          key="locations"
          text
          :class="{
            'layer-btn': true,
            active: state.layerToggles.locations,
          }"
          @click="toggleLayer('locations')"
        >
          <v-row align="center" class="flex-column" justify="center">
            <img class="layer-btn-img rounded-lg" src="../../assets/map/LocationsLayer.png" />
            <span class="text-subtitle-2 text-capitalize"> Locations </span>
          </v-row>
        </v-btn>
      </v-col>
      <v-col>
        <v-btn
          key="jobs"
          text
          :class="{
            'layer-btn': true,
            active: state.layerToggles.jobs,
          }"
          @click="toggleLayer('jobs')"
        >
          <v-row align="center" class="flex-column" justify="center">
            <img class="layer-btn-img rounded-lg" src="../../assets/map/JobsLayer.png" />
            <span class="text-subtitle-2 text-capitalize"> Jobs </span>
          </v-row>
        </v-btn>
      </v-col>
      <v-col>
        <v-btn
          key="resources"
          text
          :class="{
            'layer-btn': true,
            active: state.layerToggles.resources,
          }"
          @click="toggleLayer('resources')"
        >
          <v-row align="center" class="flex-column" justify="center">
            <img class="layer-btn-img rounded-lg" src="../../assets/map/ResourcesLayer.png" />
            <span class="text-subtitle-2 text-capitalize"> Resources </span>
          </v-row>
        </v-btn>
      </v-col>
    </v-row>
  </v-card>
</template>

<script setup lang="ts">
import { useFieldView } from './FieldViewState'

const { fieldViewState: state, toggleLayer } = useFieldView()
</script>

<style scoped>
.layer-btn {
  width: 92px;
  height: 112px !important;
  span {
    color: var(--color-grey) !important;
    font-family: var(--font-display) !important;
    font-weight: 600;
    font-size: 9pt !important;
  }
}
.layer-btn.active {
  background-color: inherit !important;
  span {
    color: var(--color-blue) !important;
  }
}
.layer-btn:hover {
  span {
    color: var(--color-blue) !important;
  }
}

.layer-btn:hover::before,
.layer-btn::before {
  opacity: 0 !important;
}
.layer-btn.active:hover::before,
.layer-btn.active::before {
  opacity: 0 !important;
}

.layer-btn .layer-btn-img {
  border: solid 3px transparent;
  margin: 2px;
  width: 80px;
}

.layer-btn.active .layer-btn-img {
  border: solid 3px var(--color-blue);
}

.layers-menu {
  padding: var(--space-small) var(--space-base);
  padding-bottom: 2px;
}
</style>
